module.exports = "<table class=\"table table-hover\">\n  <thead>\n    <th>ID</th>\n    <th>Názov</th>\n    <th>Adresa</th>\n    <th>Vlastník</th>\n  </thead>\n  <tbody>\n    <tr ng-repeat=\"item in source.result\">\n      <td>\n        <a ui-sref=\"objekt({id: item.id})\">\n          {{item.id}}   \n        </a><br>\n      </td>\n      <td>\n        <a ui-sref=\"objekt({id: item.id})\">\n          {{item.nazov}}   \n        </a><br>\n      </td>\n      <td>\n        {{item.adresa}}\n      </td>\n      <td>\n        {{item.zakaznik.nazov}}\n      </td>\n  </tbody>\n</table>"


//////////////////
// WEBPACK FOOTER
// ./src/objekty/objekt.list.table.html
// module id = 444
// module chunks = 0